import { useMutation, useQuery } from "react-query";
import {
    deleteDriverListContent,
    deletePartnerContent,
    deleteVehicleListContent,
    getDriverContent,
    getDriverListContent,
    getHomeContent,
    getPartnerContent,
    getVehicleContent,
    getVehicleListContent,
    patchDriverContent,
    patchDriverListContent,
    patchHomeContent,
    patchPartnerContent,
    patchVehicleContent,
    patchVehicleListContent,
    postDriverListContent,
    postPartnerContent,
    postVehicleListContent
} from "../API/ContentAPI";

// region Home content hooks
export const useGetHomeContent = () => {
    return useQuery({
        queryKey: ["home-content"],
        queryFn: () => getHomeContent(),
        refetchOnWindowFocus: false,
    });
};

export const usePatchHomeContent = ({ onSuccess, onError }) => {
    return useMutation(
        {
            mutationFn: (data) => patchHomeContent(data),
            onSuccess: onSuccess,
            onError: onError,
        }
    );
};
// endregion

// region Partner content hooks
export const useGetPartnerContent = () => {
    return useQuery({
        queryKey: ["partner-content"],
        queryFn: () => getPartnerContent(),
        refetchOnWindowFocus: false,
    });
};

export const usePostPartnerContent = ({ onSuccess, onError }) => {
    return useMutation(
        {
            mutationFn: (data) => postPartnerContent(data),
            onSuccess: onSuccess,
            onError: onError,
        }
    );
};

export const useDeletePartnerContent = ({ onSuccess, onError }) => {
    return useMutation(
        {
            mutationFn: (id) => deletePartnerContent(id),
            onSuccess: onSuccess,
            onError: onError,
        }
    );
};

export const usePatchPartnerContent = ({ onSuccess, onError }) => {
    return useMutation(
        {
            mutationFn: (data) => patchPartnerContent(data),
            onSuccess: onSuccess,
            onError: onError,
        }
    );
};
// endregion

// region Driver content hooks

export const useGetDriverContent = () => {
    return useQuery({
        queryKey: ["driver-content"],
        queryFn: () => getDriverContent(),
        refetchOnWindowFocus: false,
    });
};

export const usePatchDriverContent = ({ onSuccess, onError }) => {
    return useMutation(
        {
            mutationFn: (data) => patchDriverContent(data),
            onSuccess: onSuccess,
            onError: onError,
        }
    );
};

export const useGetDriverListContent = () => {
    return useQuery({
        queryKey: ["driver-list-content"],
        queryFn: () => getDriverListContent(),
        refetchOnWindowFocus: false,
    });
};

export const useDeleteDriverListContent = ({ onSuccess, onError }) => {
    return useMutation(
        {
            mutationFn: (id) => deleteDriverListContent(id),
            onSuccess: onSuccess,
            onError: onError,
            refetchOnWindowFocus: false,
        }
    );
};

export const usePatchDriverListContent = ({ onSuccess, onError }) => {
    return useMutation(
        {
            mutationFn: (data) => patchDriverListContent(data),
            onSuccess: onSuccess,
            onError: onError,
            refetchOnWindowFocus: false,
        }
    );
};

export const usePostDriverListContent = ({ onSuccess, onError }) => {
    return useMutation(
        {
            mutationFn: (data) => postDriverListContent(data),
            onSuccess: onSuccess,
            onError: onError,
            refetchOnWindowFocus: false,
        }
    );
};


// endregion

// region Vehicle content hooks
export const useGetVehicleContent = () => {
    return useQuery({
        queryKey: ["vehicle-content"],
        queryFn: () => getVehicleContent(),
        refetchOnWindowFocus: false,
    });
};

export const usePatchVehicleContent = ({ onSuccess, onError }) => {
    return useMutation(
        {
            mutationFn: (data) => patchVehicleContent(data),
            onSuccess: onSuccess,
            onError: onError,
        }
    );
};

export const useGetVehicleListContent = () => {
    return useQuery({
        queryKey: ["vehicle-list-content"],
        queryFn: () => getVehicleListContent(),
        refetchOnWindowFocus: false,
    });
};

export const useDeleteVehicleListContent = ({ onSuccess, onError }) => {
    return useMutation(
        {
            mutationFn: (id) => deleteVehicleListContent(id),
            onSuccess: onSuccess,
            onError: onError,
            refetchOnWindowFocus: false,
        }
    );
};

export const usePatchVehicleListContent = ({ onSuccess, onError }) => {
    return useMutation(
        {
            mutationFn: (data) => patchVehicleListContent(data),
            onSuccess: onSuccess,
            onError: onError,
            refetchOnWindowFocus: false,
        }
    );
};

export const usePostVehicleListContent = ({ onSuccess, onError }) => {
    return useMutation(
        {
            mutationFn: (data) => postVehicleListContent(data),
            onSuccess: onSuccess,
            onError: onError,
            refetchOnWindowFocus: false,
        }
    );
};

// endregion

